import { SMS_VERIFICATION } from 'constants/apiPrefix';

export const SKIP_ERROR_POPUP = [SMS_VERIFICATION];
